import { useHistory, useLocation } from 'react-router-dom';

/**
 * @param {string} parameterName
 * @returns
 */
export default function useURLSearchParams(parameterName) {
  const location = useLocation();
  const history = useHistory();

  const urlParams = new URLSearchParams(location.search);

  const getValue = () => urlParams.get(parameterName);
  const setValue = (v = '') => {
    if (!v) {
      urlParams.delete(parameterName);
    } else if (urlParams.has(parameterName)) {
      urlParams.set(parameterName, v);
    } else {
      urlParams.append(parameterName, v);
    }

    history.replace({
      search: decodeURIComponent(urlParams.toString()),
    });

    return urlParams;
  };

  return [getValue, setValue];
}
